import React from 'react';
import { Typography } from '@mui/material';

const MobilityEngagements = () => (
  <Typography variant="h2">Mobility Engagements</Typography>
);

export default MobilityEngagements;
